import React from "react";
import { Box, Typography } from "@mui/material";
import MessageListItem from "../MessageListItem/MessageListItem";
import { ICorporateEventMessage } from "../../../../../interfaces/corporateEvent";
import "./MessagingContainer.scss";

interface IMessagingContainerProps {
	chat: ICorporateEventMessage;
	expanded: boolean;
	onChatClick: () => void;
}

const MessagingContainer: React.FC<IMessagingContainerProps> = ({ chat, onChatClick, expanded }) => {
	return (
		<Box className={`messagingContainer ${expanded ? "messagingContainer__expanded" : ""}`}>
			<div id="corporateEventDetailsTag_messaging" />
			<Typography className="messagingHeaderTitle">Messaging</Typography>
			{/* Messages List Section */}
			{chat && <MessageListItem key={chat?.corporateEventVendorId} message={chat} onClick={onChatClick} />}
		</Box>
	);
};

export default MessagingContainer;
